import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/dashboard/audit-logs")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/audit-logs" });
	},
});
